import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                toggleDate: 'toggleDate',
            },
        };

        this.ajaxurl = '/wp/wp-admin/admin-ajax.php';
    }

    init() {
      
    }

    toggleDate(e) {
        const el = e.currentTarget;
        let id = el.getAttribute('data-id');
        let target = this.$('content')[0];   
        let items = this.$('toggleDate');

        items.forEach(element => { 
            element.classList.remove('is-active');
        });

        $.ajax({
            url: this.ajaxurl,
            type: 'POST',
            data: {'action': 'togglePalmares', 'id': id},
            success: function( response ){
                if(response.content && target) {
                    $(target).html(response.content);
                    el.classList.add('is-active');
                }
            },
        });
    }
}
